import {useDispatch} from "react-redux";
import {logoutUser} from "../../actions/session";
import {useEffect} from "react";
import {Navigate} from "react-router-dom";

export const route = '/logout';

const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logoutUser());
  });
}

export default Logout;